/**
 * Rewrites LMS Windows document paths using system config IMAGE_PATH
 * and optionally appends fileName.
 *
 * C:/Upload\CAM_AUTOMATION\122533 + ANIL_....png
 * → /mnt/windows_lun/Upload/CAM_AUTOMATION/122533/ANIL_....png
 */

export const DEFAULT_LMS_IMAGE_PATH = '/mnt/windows_lun';

export function resolveLmsDocumentPath(
  documentPath?: string | null,
  fileName?: string | null,
  imageRoot?: string | null,
): string | null {
  if (documentPath == null || String(documentPath).trim() === '') {
    return documentPath ?? null;
  }

  const trimmed = String(documentPath).trim();
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:')) {
    return trimmed;
  }

  const root = (imageRoot?.trim() || DEFAULT_LMS_IMAGE_PATH).replace(/\/+$/, '');
  let normalized = trimmed.replace(/\\/g, '/');
  normalized = normalized.replace(/^[A-Za-z]:\//, `${root}/`);
  normalized = normalized.replace(/\/{2,}/g, '/');

  const name = fileName ? String(fileName).trim().replace(/^\/+/, '') : '';
  if (name) {
    const folder = normalized.replace(/\/+$/, '');
    if (!folder.toLowerCase().endsWith(`/${name.toLowerCase()}`)) {
      normalized = `${folder}/${name}`;
    }
  }

  return normalized;
}
